<div class="line-height-selector flex-row gap-4">
  <nw-icon type="format_line_spacing" color="white"></nw-icon>
  <div *ngIf="currentLineHeight && currentLineHeight !== 1" class="fs-11">
    {{ currentLineHeight }}
  </div>
</div>
